import { InjectionToken } from '@angular/core';

export enum EntityStoreKey {
  DevFlags = 'DevFlags',
}

export type DevFlagsMap = Record<DevFlag, boolean>;
export const DEV_FLAGS = new InjectionToken<DevFlagsMap>('DevFlagsMap');

export enum DevFlag {
  DisableZiggeo = 'disable-ziggeo',
  Referrals = 'referrals', // This flag should be migrated to pricing features after release
  EventDebug = 'debug_event_tracking',
  Hotjar = 'hotjar',
  NewTalentPools = 'new_talent_pools',
  PP24Enabled = 'pp24_enabled',
  TellentSas = 'tellent_sas',
  LinkedInRSC = 'linkedin_rsc',
  Onboarding = 'onboarding',
  ViewsCandidates = 'views_candidates',
  ReportsExportImprovements = 'reports_export_improvements',
  ReportsExportImprovementsDebug = 'export_improvements_debug',
  EventRsvp = 'event_rsvp',
  NewDashboard = 'new_dashboard',
  NewJobDashboard = 'new_job_dashboard',
  ProsemirrorInJobEditor = 'prosemirror_in_job_editor',
  ProsemirrorInTalentPoolEditor = 'prosemirror_in_talent_pool_editor',
  PromoteKiwiHR = 'promote_kiwihr',
  NotesSearchDisabled = 'notes_search_disabled',
}
